<template>
  <div class="detail-container">
    <h1>ユーザ詳細</h1>
    <div v-if="user">
      <table class="table table-bordered">
        <tr>
          <th>ユーザ名</th>
          <td>{{ user.name }}</td>
        </tr>
        <tr>
          <th>メールアドレス</th>
          <td>{{ user.email }}</td>
        </tr>
        <tr>
          <th>現在システムの権限</th>
          <td>{{ roleLabel(user.role) }}</td>
        </tr>
        <tr>
          <th>システム別権限</th>
          <td>
            <div
              v-for="clientSystem in clientSystems"
              :key="clientSystem.key"
              class="mb-1"
            >
              {{ clientSystem.label }}: {{ roleLabel(user.roles_by_system?.[clientSystem.key]) }}
            </div>
          </td>
        </tr>
      </table>

      <div class="btn-area">
        <router-link :to="{ name: 'UserList', params: { id: user.id }}">
          <button type="button" class="btn btn-primary">一覧へ</button>
        </router-link>

        <router-link v-if="isAdmin" :to="{ name: 'UserEdit', params: { id: user.id }}">
          <button type="button" class="btn btn-success mx-2">編集</button>
        </router-link>
      </div>
    </div>
    <div v-else>
      ユーザー情報を読み込み中...
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getUser, getUserRoleCatalog } from '@/api/axios';
import { currentRoleFromStoreOrLocalStorage, isAdminRole } from '@/utils/roleAuthorization';

export default {
  setup() {
    const title = ref('ユーザ詳細');
    const store = useStore();
    const route = useRoute();
    const userId = route.params.id;

    const user = ref({});
    const clientSystems = ref([]);
    const roleOptions = ref([]);

    watchEffect(() => {
      document.title = title.value;
    });

    const isAdmin = computed(() => isAdminRole(currentRoleFromStoreOrLocalStorage(store.state.userRole)));

    const roleLabel = (roleValue) => {
      const matched = roleOptions.value.find((option) => Number(option.value) === Number(roleValue));
      return matched?.label || roleValue || '-';
    };

    const fetchUser = async () => {
      const response = await getUser(userId);
      user.value = response.data;
    };

    const fetchRoleCatalog = async () => {
      const response = await getUserRoleCatalog();
      clientSystems.value = response.data.client_systems || [];
      roleOptions.value = response.data.role_options || [];
    };

    onMounted(async () => {
      await Promise.all([fetchUser(), fetchRoleCatalog()]);
    });

    return {
      title,
      isAdmin,
      user,
      clientSystems,
      roleLabel
    };
  }
};
</script>

<style scoped>
.detail-container {
  width: 70%;
  padding: 20px;
  margin: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.detail-item {
  margin-bottom: 10px;
}

table th {
  background: #2c3e50;
  color: #fff;
}

table th,
table td{
  padding: 8px;
}

.btn-area{
  text-align: center;
}
</style>
